const reducer = (state , action) =>
{
    if (state == undefined)
    {
       return {authenticated: false, engine: undefined, profile: undefined};
    }
    switch(action.type)
    {
        case "USER:INIT":
            return {authenticated :false, engine: action.engine, profile: undefined};
        case "USER:AUTHENTICATED":
            return {authenticated : action.authenticated, engine : action.engine, profile: undefined};
        case "USER:LOGOUT":
            state.authenticated = false;
            state.profile = undefined;
            return state;
        case "USER:PROFILE":
            state.profile = action.profile;
            return state;
        default:
            return state;
    }
}

export {reducer};
